import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import store from './store'
import VueResource from 'vue-resource';
import ElementUI from 'element-ui';
import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false

Vue.use(VueResource);
Vue.use(ElementUI);
Vue.use(VueLazyload);

new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js